<template>
  <div>
       <h1 style="display: none">Conviertete en una empresa con proposito midiendo tu huella de cabono</h1>
        <div class="md-layout md-head-water mt-2">
            <div class="md-layout-item md-small-size-100 md-size-65">
                <h1 class="calcHead head-sellos" style="margin-bottom: 2px !important; margin-top: 15px !important;color: #707070;"> 
                    DETÉN EL CAMBIO CLIMÁTICO,
                </h1>
                <h1 class="calcHead head-sellos" style="margin-top: 2px !important;">GESTIONA TU HUELLA DE CARBONO</h1>
                <div>
                    <p class="headPara md-small-hide">La huella de carbono es el conjunto de emisiones que impactan en el cambio climático, <br /> causadas de manera directa e indirecta, ya sea por una persona, organización, evento o producto.</p>
                </div>
            </div>
        
            <div class="md-layout-item right-side-head md-small-size-100" style="position: relative;">
                <img src="@/assets/CARBON-FOOTPRINT.png" alt="Huella de carbono" srcset="" class="head-right-image-seil" >
            </div>

            <div class="md-layout-item  md-small-size-100 md-medium-hide">
              <p class="headPara">La huella de carbono es el conjunto de emisiones que impactan en el cambio climático, <br /> causadas de manera directa e indirecta, ya sea por una persona, organización, evento o producto.</p>
            </div>
        </div>
        <Gestion />
        <CuadroCarbon />
        <secondSection />
  </div>
</template>

<script>
import secondSection from '@/components/secondSection.vue'
import Gestion from '@/components/Gestion.vue'
import CuadroCarbon from '@/components/Cuadro-carboon.vue'
export default {
    components: {secondSection, Gestion, CuadroCarbon},
    name: 'carbonfootprint',
    metaInfo: {
      title: 'Calcula tu huella de carbono | Reduce | Gestiona | Compensa con Green Solutions',
      meta: [
        { name: 'description', content: 'Calculo y Gestión de Huella de Carbono Corporativa y de Producto | Reducción y Neutralización. En Green Solutions, líderes en Chile y América Latina, medimos, reducimos y compensamos las emisiones de GEI. Ayudamos a empresas a adoptar prácticas sostenibles y a reducir su huella de carbono. Contáctanos para un futuro más limpio y responsable.' }
      ]
    },
    data () {
        return {

        }
    }
}
</script>

<style>
.huella-item {
  font-size: 1vw;
  text-align: center;
}

.head-right-image-seil {
  width: 100%;
  position: absolute;
  top: -5%;
  right: -20%;
}
.text-sellos {
  font-size: 1.1vw;
  padding-top: 2rem;
  text-align: justify;
}
.sellos-seccion {
  margin-top: 3vw
}

.sellos-seccion img {
  width: 60%;
  height: 60%;
}
.calcHead {
  font-size: 4vw;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.24;
  letter-spacing: -1.44px;
  text-align: left;
  color: #00d371;
}
.headPara {
  font-size: 1.4vw;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.65;
  letter-spacing: -0.52px;
  text-align: left;
  color: #707070;
}
 .md-head-layout {
   margin: 1vw 1vw 3vw 7vw;
 }  
</style>